import { render, staticRenderFns } from "./CartQuantity.vue?vue&type=template&id=2ce504f2&scoped=true"
import script from "./CartQuantity.vue?vue&type=script&lang=js"
export * from "./CartQuantity.vue?vue&type=script&lang=js"
import style0 from "./CartQuantity.vue?vue&type=style&index=0&id=2ce504f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce504f2",
  null
  
)

export default component.exports